import { IFeedMetaData } from 'js/crossword/types';
import { getMetaDataServiceUrl } from 'js/crossword/sdk/getMetaDataServiceUrl';
import { getFeedSlug } from 'js/crossword/getYearsInfo';
import { createDate } from './helpers/dateHelpers';

const cache: Record<string, IFeedMetaData[]> = {};

export function fetchMonthMetaData(year: number, month: number): Promise<IFeedMetaData[]> {
  const cacheKey = `${year}-${month}`;

  return new Promise((resolve) => {
    if (cache[cacheKey]) {
      resolve(cache[cacheKey]);
      return;
    }

    const req = new XMLHttpRequest();
    const url = getUrl(year, month);
    req.open('GET', url, true);
    req.addEventListener('load', () => {
      const data = JSON.parse(req.responseText).filter((puzzleData) => {
        return createDate(puzzleData.date).getTime() < Date.now();
      });
      cache[`${year}-${month}`] = data;
      resolve(data);
    });
    req.send();
  });
}

function getUrl(year: number, month: number): string {
  // months in service stars from 1, not from 0 like in js Date
  return `${getMetaDataServiceUrl()}/feed/${getFeedSlug()}/year/${year}/month/${month + 1}`;
}
